<section [ngClass]="{
  'calendar-grid': true,
  'week': viewType==='week',
}">

  <!-- Column header for each day -->
  <ol class="day-container" *ngFor="let day of weekdays">
    <li class="day-label">{{day}}</li>
  </ol>

  <!-- Events for each day -->
  <ol *ngFor="let day of calendarDays; let dayIndex = index;" [ngClass]="{
    'day-container': true,
    'day-outside-month': viewType==='month' && !day.isCurrentMonth,
    'today': day.isToday,
 }">
    <li class="day-number" (click)="onDayClick(day)" [ngStyle]="{
      'padding-bottom': this.maxEventsPerDay === 0 ? '5px' : '0',
    }">
      <span>{{day.date | date:'d'}}</span>
    </li>

    <!-- Daily events (multiday events in week view / all events in month view) -->
    <li class="events-container" (click)="onDayClick(day)" *ngIf="maxEventsPerDay > 0" [ngStyle]="{
      'grid-template-rows': 'repeat(' + (
        viewType==='week' && maxEventsPerDay <= monthMaxEventsPerDay
        ? maxEventsPerDay
        : monthMaxEventsPerDay + 1) + ', minmax(0, 18px))',
      }" [ngClass]="{
      'has-events': day.events.length > 0,
      }">
      <a class="event" *ngFor="let event of day.events.slice(0, monthMaxEventsPerDay)">
        <span class="event-time" *ngIf="!event.totalOccurrences || event.occurrenceNumber === 1">
          {{ event.startDate | date:'h' }}{{ (event.startDate | date:'mm') === '00' ? '' : (event.startDate |
          date:':mm')}}{{event.startDate | date:'aaaaa' | lowercase}}
        </span>
        {{event.name}}
      </a>
      <a class="more-events" *ngIf="day.events.length > monthMaxEventsPerDay">
        <span>
          +{{day.events.length - monthMaxEventsPerDay}}
          <span class="more-label">more</span>
        </span>
      </a>
    </li>

    <!-- Hourly events (week view) -->
    <ng-container *ngIf="viewType ==='week'">

      <!-- Day column -->
      <li class="events-container hourly" [ngStyle]="{
        'grid-template-columns': 'repeat(' + day.gridColumns + ', 1fr)',
        'grid-template-rows': 'repeat(' + displayHours.length * 4 + ', 20px)',
      }">

        <!-- Hour labels for first column -->
        <div class="hour-label-column" *ngIf="dayIndex === 0">
          <ng-container *ngFor="let hour of displayHours">
            <div class="hour-label">
              {{ hour | date:'ha' | lowercase}}
            </div>
            <!-- Extra div for half hour line -->
            <div class="hour-half">&nbsp;</div>
          </ng-container>
        </div>

        <!-- Events (placed using grid row) -->
        <div class="event-container" *ngFor="let event of day.hourlyEvents;" [ngStyle]="{
            'grid-row': getGridRow(event),
            'grid-column': getGridColumn(event, day),
            'padding-left': event.column === 0 ? null : '0',
          }" [ngClass]="{
            'single-line': isSingleLine(event),
            'double-line': isDoubleLine(event),
          }" (click)="onSingleEventClick(event)">
          <a class="event">
            <span class="event-time">
              {{ event.startDate | date:'h' }}{{ (event.startDate | date:'mm') === '00' ? '' : (event.startDate |
              date:':mm')}}{{event.startDate | date:'aaaaa' | lowercase}}
            </span>
            <span class="event-name">
              {{event.name}}
            </span>
          </a>
        </div>
      </li>
    </ng-container>
  </ol>

</section>
